import React, { Component, Fragment } from 'react';
import { PageWrapper, ErrorRedirect, PageLoader, SocialShare, RelatedPosts, Hero, Press, HelmetWrap} from './../components';
import ExPubDetail from './ex-pub-gallery/ExPubDetail';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    this.slug = `${process.env.API_URL}exhibition/?name=`;
  }

  componentDidMount() {
    this._apiRequest(`${this.slug}${this.props.match.params.pageSlug}`);
  }
  
  componentWillReceiveProps(nextProps) {
    this._apiRequest(`${this.slug}${nextProps.match.params.pageSlug}`);
  }

  _apiRequest(url) {
    fetch(url).then((response) => {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }).then((res) => {
      this.setState({
        wpData: res.data,
        loading: false,
        error: false
      });
    }).catch(() => {
      this.setState({
        error: true,
        loading: false,
        wpData: false
      });
    });
  }

  render() {
    return (
      <Fragment>
        {(this.state.loading) ? <PageLoader/> : (this.state.error) ? <ErrorRedirect/>
          : <ExhibitionContent data={this.state.wpData}/>
        }
      </Fragment>
    );
  };
};

const ExhibitionContent = (props) => {
  return (
    <PageWrapper pageId={'publication-detail'}>
      <ExPubDetail data={props.data}>
        <div>
          <div className="date">{props.data.exhibition_date}</div>
          <div className="text" dangerouslySetInnerHTML={{ __html: props.data.side_info }} />
          {(props.data.gallery_url)
            && <p className="text gallery-url"><a href={props.data.gallery_url}>{props.data.gallery_url}</a></p>
          }
        </div>
      </ExPubDetail>
      <SocialShare Meta={props.data.page_meta} />
      <RelatedPosts Posts={props.data.related_posts.posts}/>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/SingleExhibition.js